module.exports = __webpack_public_path__ + "static/media/imgcap2.a746b74a.jpg";